import type { PropsWithChildren } from "react";

import { StyledFixedGatewayActions } from "./styles";

export const StickyGatewayActionsBar = ({ children }: PropsWithChildren): React.ReactElement => (
    <StyledFixedGatewayActions data-automation="gateway-fixed-actions-bar">{children}</StyledFixedGatewayActions>
);
